import PageContent from "~/components/design-system/pages/internal/PageContent"
import PageToolbar from "~/components/design-system/pages/internal/PageToolbar"
import {
  useRegisterInspector,
  useRegisterViewConfiguration,
} from "~/components/design-system/pages/internal/InspectorContext"
import { type WorkspacePageProps } from "~/components/design-system/pages/types"

/**
 * Archetype page — single primary interactive surface (table, editor).
 * Rule: NO charts / tiles / cards in the main column — they go in the inspector.
 * Defaults: p-4, optional sticky toolbar, inspector closed by default.
 * Canonical intent: {@link ../intents.ts WORKSPACE_PAGE_INTENT}.
 * Approved surface: design-system/APPROVED.md · Patterns: design-system/pages/README.md.
 */
const WorkspacePage = ({
  children,
  toolbar,
  inspector,
  inspectorDefaultOpen = false,
  inspectorWidth = "md",
  inspectorClassName,
  contentClassName,
  viewConfiguration,
}: WorkspacePageProps) => {
  useRegisterInspector(inspector, inspectorDefaultOpen, inspectorWidth, inspectorClassName)
  useRegisterViewConfiguration(viewConfiguration)
  return (
    <>
      {toolbar && <PageToolbar>{toolbar}</PageToolbar>}
      <PageContent archetype="workspace" className={contentClassName}>
        {children}
      </PageContent>
    </>
  )
}

export default WorkspacePage
